<template>
       <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <slot name="modal-header">
              </slot>
              <slot name="modal-body">
              </slot>
              <slot name="modal-footer">
              </slot>
            </div>
          </div>
       </div>
</template>
<style lang="scss" scoped>

</style>
<script>
export default {
  props:{
    id: String
  },
  data(){
    return{

    }
  }
}
</script>